import React from 'react'
import {getUserSettings} from '../../storage'
import DefaultCredit from './addcreditnote'
import BatchCredit from './batchcredit'
export default class InvoiceMode extends React.Component {


  render()  {
    let settings = getUserSettings()
    if(typeof settings !== "undefined" && settings !== null && settings.item_track_batches) {
        return <BatchCredit {...this.props} />
    }
    else {
        return <DefaultCredit {...this.props} />
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/credit/creditselect.js